<template>
  <div class="h6 mb-0">
    <!-- <div :content="errorLampDesc(lamp)"> -->
    <div>
        <!-- errore di comunicazione CPU-AK che si propaga anche alle linee e alle lampade -->
        <div v-if="dev.error_com_cpu_ak === 'ON'" :content="errorDesc" v-tippy="{ placement : 'top',  arrow: true}">
            <b-iconstack :font-scale="scalefont">
                <b-icon stacked icon="slash" style="color:red"></b-icon>
                <b-icon stacked icon="arrow-left-right" style="color:red"></b-icon>
            </b-iconstack>
        </div>

        <!---- gestione tipo di errore -->
        <i v-else 
            :class="['fa', scale, dotClass]" 
            :content="errorDesc" 
            v-tippy="{ placement: 'top', arrow: true }"
        />

    </div>
  </div>
</template>

<script>

export default {
    name: "IconErrorAkChargerSwitch",
    props: {
        dev: {
            default: null
        },
        tipo: null,
        scale: {
            type: String,
            default: 'fa-2x'
        },
        scalefont: {
            type: String,
            default: '2.5'
        }
    },
    data() {
        return {
        };
    },

    mounted() {
        // console.log("IconError: ", this.dev);
    },

    computed: {
        dotClass()
        {
            var stato = null;
            switch(this.tipo) {
                case 'charger':
                    if (this.dev.error_com_cpu_charger === 'ON') {
                        stato = "fa-exclamation-circle check-com-err";
                    }
                    else if (this.dev.error_all_charger_or_fuse === 'ON' || this.dev.error_overtemperature === 'ON' || this.dev.error_hardware === 'ON') {
                        stato= "fa-exclamation-circle check-err";
                    } else {
                        stato = "fa-check check-ok";
                    }
                    break;
                
                case 'switch11kw':
                   if (this.dev.error_com_cpu_switch11kw === 'ON') {
                        stato = "fa-exclamation-circle check-com-err";
                    } else {
                        stato = "fa-check check-ok";
                    }
                    break;

                case 'ak':
                    if ((this.dev.error_line_isolation === 'ON') || (this.dev.num_lamp_error > 0) || (this.dev.num_line_error > 0)) {
                        stato= "fa-exclamation-circle check-err";
                    } else {
                        stato = "fa-check check-ok";
                    }
                    break;

                case 'line':
                    if ((this.dev.error_ak_su_current === 'ON') || (this.dev.error_line_fuse === 'ON') || (this.dev.error_line_isolation === 'ON') || (this.dev.num_lamp_error>0)) {
                        stato= "fa-exclamation-circle check-err";
                    } else {
                        stato = "fa-check check-ok";
                    }
            }
                return stato;
        },


        errorDesc()
        {

            var stato_desc = "";

            switch(this.tipo) {
                case 'charger':
                    if(this.dev.error_hardware === "ON") {
                        stato_desc= this.$t("details_lamp.lamp_error_hardware");
                    } else if (this.dev.error_all_charger_or_fuse === 'ON') {
                        stato_desc = this.$t('charger.err_charger_fuse');
                    } else if (this.dev.error_com_cpu_charger === 'ON') {
                        stato_desc = this.$t('charger.err_com');
                    } else if (this.dev.error_overtemperature === 'ON') {
                        stato_desc = this.$t('charger.err_over_temp');
                    } else {
                        stato_desc= this.$t('details_lamp.lamp_no_error');
                    }
                    break;
                case 'switch11kw':
                    if (this.dev.error_com_cpu_switch11kw === 'ON') {
                        stato_desc = this.$t('charger.err_com');
                    } else {
                        stato_desc= this.$t('details_lamp.lamp_no_error');
                    }
                    break;
 
                case 'ak':
                    if (this.dev.error_com_cpu_ak === 'ON') {
                        stato_desc = this.$t('details_cu_modal.cu_error_com_cpu_AK');
                    } else if (this.dev.error_line_isolation === 'ON') {
                        stato_desc = this.$t('ak.line_isolation_err');
                    } else if (this.dev.num_lamp_error > 0) {
                        stato_desc = this.$t('report_pdf.num_lampade_fail');
                    } else if (this.dev.num_line_error > 0) {
                        stato_desc = this.$t('details_cu_modal.lines_error');
                    } else {
                        stato_desc = this.$t('details_lamp.lamp_no_error');
                    }
                    break;

                case 'line':
                    if (this.dev.error_com_cpu_ak === 'ON') {
                        stato_desc = this.$t('details_cu_modal.cu_error_com_cpu_AK');
                    } else if (this.dev.error_ak_su_current === 'ON') {
                        stato_desc = this.$t('details_line.err_ak_su_current');
                    } else if (this.dev.error_line_fuse === 'ON') {
                        stato_desc = this.$t('details_line.error_fuse');
                    } else if (this.dev.error_line_isolation === 'ON') {
                        stato_desc = this.$t('details_line.error_isolation');
                    } else if (this.dev.num_lamp_error>0) {
                        stato_desc = this.$t('report_pdf.num_lampade_fail');    
                    } else {
                        stato_desc = this.$t('details_lamp.lamp_no_error');
                    }
                }

            return stato_desc;
        },
    },

    methods: {

    }
   
  }
  
</script>
